// extracted by mini-css-extract-plugin
export default {"containerList":"CustomCardList_containerList__Qc93D"};